import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ApiError } from '@/utils/types';
import { fetchMaterialMatchSummaryDetail } from '../api/fetch-match-summary-detail.api';

export const getMaterialMatchSummary = createAsyncThunk(
  'MatchMaker/getMaterialMatchSummary',
  async (_, thunkAPI) => {
    try {
      // Call API to get material match summary
      return await fetchMaterialMatchSummaryDetail();
    } catch (e: unknown) {
      // Return error if API call fails
      return thunkAPI.rejectWithValue(
        (e as ApiError).message ||
          'Failed to fetch material match summary detail'
      );
    }
  }
);
